import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { Button } from '../_atoms';
import { LoaderSpinner } from './loaderAndSpinners';
import { BooksInAddind } from './books_in_adding';
import { BooksInExemlar } from './books_in_exemplar';
import { BooksInExemlarCover } from './books_in_exemplar_cover';
import { putPicture } from '../redux/actions/pictures';
import { deletePicture, changeOrderOfPictures } from '../redux/reducers/picturesReducer';
import backImg from '../styles/images/icons/back.png';
import '../styles/books_in.scss';
import { useScrollTop } from '../helpers/useScrollTop';

const loaderInitial = { loader: 0, showLoader: false, showAnswer: false, showLineLoader: false };

export const buildGallery = ({ mass, tagName, count, ...props }) => {
  const length = count === null ? Math.ceil((mass.length + 1) / 4) : count;

  const massPhoto = [];
  for (let i = 0; i < length; i += 1) {
    massPhoto.push(
      React.createElement(
        tagName,
        {
          key: `1${i}`,
          images: mass.slice(i * 4, i * 4 + 4),
          num: i * 4 + 1,
          ...props,
        },
        null
      )
    );
  }
  return massPhoto;
};

const mass = [
  'photo-book-RU',
  'photo-book-RU-light',
  'photo-book-RU-slim',
  'photo-book-RU-soft',
  'postcards-product-self-sending',
  'postcards-product-send-for-me',
];
const massCopies = [
  'ny_products',
  // 'photo-book-RU',
  // 'photo-book-RU-slim',
  'photo-foam-board',
  // 'photo-book-RU-light',
  // 'photo-book-RU-soft',
  'notebook-RU',
  // 'photo-mosaic',
  'postcards-product-self-sending',
  'postcards-product-send-for-me',
  'portrait-on-canvas',
  'calendar-RU-table',
  'calendar-RU',
  'calendar-RU-magnet',
  'photo-pillow-RU',
  'photo-poster-RU',
  'photo-strip-RU',
];
const useShowImagesCopies = (categoryId, productId) =>
  [
    'canvas-dream-art',
    'portrait-on-canvas',
    'photos',
    'fotoghrafii-v-ramkie',
    'fotomaghnity',
    'fotopazly-maghnitnyie',
    'kruzhki',
    'tarielka-s-fotoghrafiiei',
    'fotopazly-kartonnyie',
    'kovrik-dlia-myshi',
    'futbolki-dlia-dietiei',
    'futbolki-dlia-vzroslykh',
  ].includes(categoryId) ||
  ['ny-products-RU-1-balls-with-1-photo', 'ny-products-RU-1-ballbox-in-gift-box-with-1-photo'].includes(productId);

export const BooksIn = ({
  hasComment,
  hasCopies,
  hasCover,
  addToBasket,
  title,
  onBack,
  product,
  productId,
  isContinue,
}) => {
  const { min, max, id } = product;
  const { query = {} } = useLocation();
  const dispatch = useDispatch();
  useScrollTop();

  const { images, coverImages } = useSelector(state => state.pictures.uploadedPictures);

  const [comment, setComment] = useState(query.comment || '');
  const [numberOfCopies, setNumberOfCopies] = useState(query.numberOfCopies || 1);

  const [dragItem, setDragItem] = useState(null);
  const [safariScroll, setSafariScroll] = useState(0);

  const [loaderState, setLoaderState] = useState(loaderInitial);

  const showCoverForId = !mass.includes(productId);
  const showCommentForId = !mass.includes(productId);
  const showCopiesForId = massCopies.includes(productId);
  const showCover = showCoverForId && hasCover && productId !== 'notebook-RU';
  const showComment = showCommentForId && hasComment && productId !== 'notebook-RU';
  const showCopies = showCopiesForId && hasCopies;
  const showImageCopies = useShowImagesCopies(productId, product.id);
  const onAddToBasket = () => addToBasket({ comment, numberOfCopies, id });

  const addPhoto = async ({ target: { name, files } }) => {
    let { length } = files;
    if (name === 'coverImages' && length + coverImages.length > 4) {
      length = 4 - coverImages.length;
    } else if (name === 'images' && max && length + images.length > max) {
      length = max - images.length;
    }
    const stepLoader = 100 / (length + 1);
    setLoaderState(s => ({ ...s, loader: stepLoader, showLoader: true, showLineLoader: true }));

    for (let i = 0; i < length; i += 1) {
      await dispatch(putPicture(files[i], name));
      setLoaderState(s => ({ ...s, loader: s.loader + stepLoader }));
    }

    if (name === 'images' && max && files.length + images.length > max) {
      setLoaderState({
        ...loaderInitial,
        showLoader: true,
        showAnswer:
          images.length === max
            ? 'Нельзя загрузить больше фотографий.'
            : 'Были загружины не все фотографии из-за привышения лимита.',
      });
    } else {
      setLoaderState(loaderInitial);
    }
  };
  const deletePhoto = (id, massName) => dispatch(deletePicture({ id, massName }));
  const onChangeCopies = e => setNumberOfCopies(e.target.value);

  const saveCurrentPictOrder = item => {
    setDragItem(item);
    setSafariScroll(window.pageYOffset);
  };

  const changePictOrder = dropItem => {
    dispatch(changeOrderOfPictures({ dropItem, dragItem }));
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    if (isSafari) {
      window.scrollTo(0, safariScroll);
    }
  };

  useEffect(() => {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }, []);

  const massPhoto = buildGallery({
    mass: images.map(i => ({
      ...i,
      rotateAngle: productId === 'photo-strip-RU' && product.orientation === 'vertical' ? 90 : 0,
    })),
    tagName: BooksInExemlar,
    count: min === max ? Math.ceil(min / 4) : null,
    addPhoto,
    deletePhoto,
    saveCurrentPictOrder,
    changePictOrder,
    showImageCopies,
  });
  const massCoverPhoto = buildGallery({
    mass: coverImages,
    tagName: BooksInExemlarCover,
    count: 1,
    addPhoto,
    deletePhoto,
    saveCurrentPictOrder,
    changePictOrder,
  });

  return (
    <div id="books_in_page" className="books-in-page">
      <img className="go-back" src={backImg} alt="" role="none" onClick={onBack} />
      <p className="books-in-page__title">{title}</p>
      {massPhoto}
      {showCover && (
        <>
          <div className="divider" />
          <p className="books-in-page__title">
            Добавьте фото, дизайн обложки мы согласуем по email после оформления заказа
          </p>
          {massCoverPhoto}
        </>
      )}
      <div className="divider" />
      {showComment && (
        <textarea
          name="comment"
          form="books_in_page"
          cols="74"
          rows="5"
          className="books-in-text"
          placeholder="Комментарий к заказу"
          wrap="hard"
          value={comment}
          onChange={e => setComment(e.target.value)}
        />
      )}
      {showCopies && (
        <>
          <p className="books-in-page__title">Кол-во экземпляров</p>
          <BooksInAddind numberOfCopies={numberOfCopies} handleChange={onChangeCopies} />
        </>
      )}
      <Button className="blue" name="currentTab" onClick={onAddToBasket}>
        {isContinue ? 'Продолжить' : 'Добавить в корзину'}
      </Button>
      <LoaderSpinner
        showLoader={loaderState.showLoader}
        showAnswer={loaderState.showAnswer}
        closeLoader={() => setLoaderState(loaderInitial)}
        showLineLoader={loaderState.showLineLoader}
        loader={loaderState.loader}
      />
    </div>
  );
};
